import { useState } from 'react';
import { Key, Network, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import Keys from './Keys';
import ApiMap from './ApiMap';
import Entities from './Entities';

type Tab = 'entities' | 'keys' | 'map';

export default function Api() {
  const { t } = useTranslation();
  const [tab, setTab] = useState<Tab>('entities');

  const tabs: Array<{ id: Tab; icon: typeof Key; label: string }> = [
    { id: 'entities', icon: Users, label: t('api.entities') },
    { id: 'keys', icon: Key, label: t('api.keys') },
    { id: 'map', icon: Network, label: t('api.map') },
  ];

  return (
    <div className='space-y-6'>
      <div className='flex items-center gap-1 border-b border-gray-800 pb-0'>
        {tabs.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.id}
              onClick={() => setTab(item.id)}
              className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-t-lg border-b-2 -mb-px transition-colors ${
                tab === item.id
                  ? 'border-blue-500 text-blue-400'
                  : 'border-transparent text-gray-500 hover:text-white'
              }`}
            >
              <Icon size={13} /> {item.label}
            </button>
          );
        })}
      </div>

      {tab === 'entities' && <Entities />}
      {tab === 'keys' && <Keys />}
      {tab === 'map' && <ApiMap />}
    </div>
  );
}
